import React, { Component, Fragment } from "react";
import axios from "axios";
import Loading from "../../components/Loading";
import nl2br from "react-nl2br";
import { gaPageview } from "../../utils/dev";

export default class ResourceSingle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      resource: {},
      meida: {}
    };

    this.loadResoruces = this.loadResoruces.bind(this);
  }
  componentDidMount() {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    //get resources from wp
    this.loadResoruces();
    gaPageview(this.props.location);
  }

  decodeHtml(data) {
    var txt = document.createElement("textarea");
    txt.innerHTML = data;
    return txt.value;
  }

  loadResoruces = () => {
    let resource = [];
    const { slug } = this.props.match.params;
    this.setState({ isLoading: true }, async () => {
      try {
        await axios.get(`resources/${slug}`).then(res => {
          resource = res.data.shift();
        });
      } catch (err) {
        console.log("Error fetchign resource from WP: ", err);
      }
      document.title = this.decodeHtml(resource.title) + " | Vetchat";
      this.setState({ resource, isLoading: false });
    });
  };

  setHtml(data) {
    return { __html: data };
  }

  render() {
    const { isLoading } = this.state;
    const { path } = this.props.match;
    const ebook = path.indexOf("ebook") !== -1 ? true : false;
    const infographic = path.indexOf("infographic") !== -1 ? true : false;

    const { resource } = this.state;
    console.log(resource);

    return (
      <Fragment>
        <div className="container">
          <div className="row">
            <div className="col-12">
              {isLoading && <Loading title={`loading resource`} />}

              {(resource === undefined || resource.length === 0) && (
                <div className="resource-single space-top text-center">
                  <h2 className="space-small-bottom">
                    No Matching resource found
                  </h2>
                </div>
              )}
              {infographic && (
                <div className="resource-single space-top text-center">
                  <h2 className="space-small-bottom">
                    {this.decodeHtml(resource.title)}
                  </h2>
                  <div className="resource-inner space-small-bottom">
                    <img
                      src={`${axios.defaults.baseURL}/uploads/${resource.file}`}
                      alt={resource.title}
                      style={{ width: "100%", height: "auto" }}
                    />
                  </div>
                </div>
              )}
              {ebook && (
                <div className="resource-single space-top text-center">
                  <h2 className="space-small-bottom">
                    {this.decodeHtml(resource.title)}
                  </h2>
                  <div className="resource-inner space-small-bottom row">
                    <div className="col-sm-4">
                      <img
                        src={`${axios.defaults.baseURL}/uploads/${
                          resource.featured_image2
                        }`}
                        alt={resource.title}
                        style={{ width: "100%", height: "auto" }}
                      />
                    </div>
                    <div className="col-sm-8 text-left">
                      <div className="resource-inner space-small-bottom">
                        {nl2br(resource.description)}
                        <div style={{ marginTop: 20 }}>
                          <p>Download Here</p>
                          <a
                            href={`${axios.defaults.baseURL}/uploads/${
                              resource.file
                            }`}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            {resource.file}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
